import { Link, useNavigate } from 'react-router-dom';
import { JAlerta, JRow } from '../components/Components';
import { AuthContext } from '../contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import auxService from '../services/AuxService';
import { useLocation } from "react-router-dom";
import { setNavigate } from '../utils/navigation';

export default function Home() {
    const [showError, setShowError] = useState(false);
    const [showMessageError, setShowMessageError] = useState('');
    const authContext = useContext(AuthContext);
     const location = useLocation();
    const state = location.state as { vencido: boolean } | null;


    

    useEffect(() => {
        auxService.getUserCurrent().then(() => {});        
       
        // if (authContext?.licenca === false)
        // {
        //     if (authContext.userLogado.is_superuser) {
        //         setShowError(true);
        //         setShowMessageError('Linceça vencida.');
        //     } else {

        //         setShowError(true);
        //         setShowMessageError('Usuário sem acesso. Contacte o adminstrador.');
        //     }
        // }

    },[])

    return (
        <div>

        {/* {state ? (
                <p>ID: {state.vencido}, </p>
            ) : (
               <> </>
            )} */}
            {/* <JRow>
                <Col md>
                    <JAlerta showError={showError} close={setShowError} 
                    messageError={showMessageError} time={5000} variant="danger" />   
                </Col>

            </JRow>
            <JRow className='d-flex justify-content-center '>

            <Col md={'auto'}>

            {(authContext?.userLogado?.is_superuser === 1 && authContext?.licenca === false) && (
                <>
                    <Link to={'/licenca'} className="btn btn-success">
                         <FontAwesomeIcon icon={faMoneyBill} /> Liberar Licença
                    </Link>
                </>
            )}
            </Col>
            </JRow> */}

        </div>
    );
};
